import { Component, input } from '@angular/core';

/**
 * Explains why a step's Continue button did not move the customer on, for the blockers that are not
 * form fields and so cannot be highlighted inline (a document still to upload, an account still to
 * select, a signature still to complete).
 *
 * Since KOR-15024 the buttons no longer disable themselves, so this line is the whole of the
 * customer's feedback that a press was refused: it reads as an error, and it sits inside a live
 * region that is always mounted, so the message arrives *into* an existing region rather than being
 * created alongside it — which is what made the previous `role="status"` announcement unreliable.
 */
@Component({
  selector: 'app-continue-blocker',
  templateUrl: './continue-blocker.component.html',
  styleUrls: ['./continue-blocker.component.scss'],
  standalone: true,
})
export class ContinueBlockerComponent {
  message = input<string>();

  /** Set when a button needs to point `aria-describedby` at this message. */
  messageId = input<string>();
}
